<div class="m-auto">
    <div *ngIf="!loading; else loadingState">
        <img class="m-auto pb-4" src="/assets/images/FAQ_Illo 1.svg" />
        <div class="text-center font-normal text-gray-400" [innerHTML]="label">
            <ng-content select="[extraContent]"></ng-content>
        </div>
    </div>

    <ng-template #loadingState>
        <app-dot-loader-scale style="margin: 0 auto"></app-dot-loader-scale>
    </ng-template>
</div>
